import * as yup from 'yup';
import { GrantType } from '../types';
import { settingsShapeByGrantType } from './constants';

const baseSettingsShape = {
  tokenUri: yup.string().required(),
};

export const getValidationSchema = (grantTypeId: GrantType) =>
  yup.object().shape({
    name: yup.string().required(),
    settings: yup
      .object()
      .shape(settingsShapeByGrantType[grantTypeId] ?? baseSettingsShape),
  });
